import React, { useState } from "react";
import { T, load } from "./theme";
import { Input, Btn, Note } from "./ui";
import { Icon } from "./Icons";
import { DEFAULT_USERS } from "./data";
import { loginUser } from "./supabaseData";

export default function Login({ onLogin, users: propUsers, dataSource }) {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function tryLogin() {
    setErr("");
    setLoading(true);

    try {
      // 1. Tenta Supabase primeiro
      const sbUser = await loginUser(u, p);
      if (sbUser) {
        setLoading(false);
        onLogin(sbUser);
        return;
      }
    } catch (e) {
      console.warn("[Login] Supabase indisponível, tentando local:", e.message);
    }

    // 2. Fallback: login local (localStorage / defaults)
    const users = propUsers || load("bap_users", DEFAULT_USERS);
    const raw = u.trim().toLowerCase().replace(/^@/, "");
    const found = users.find(x => (x.username === raw || (x.email && x.email.toLowerCase() === raw)) && x.password === p);
    setLoading(false);
    if (found) { setErr(""); onLogin(found); }
    else setErr("Usuário ou senha incorretos.");
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: T.gradient.bgRadial,
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "24px 16px",
      position: "relative",
      overflow: "hidden",
    }}>
      {/* Orbes decorativas (glow brand + gold) */}
      <div style={{
        position: "absolute", top: "-15%", right: "-10%",
        width: "50%", height: "60%",
        background: `radial-gradient(circle, ${T.brand}1a 0%, transparent 60%)`,
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", bottom: "-20%", left: "-15%",
        width: "60%", height: "70%",
        background: `radial-gradient(circle, ${T.gold}0d 0%, transparent 55%)`,
        pointerEvents: "none",
      }} />

      <div style={{ width: "100%", maxWidth: 420, position: "relative", zIndex: 1 }}>
        {/* Brand — dourado metálico grande, estilo Canva "Você vai Prosperar" */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          {/* Logo Bellanor (fundo transparente) */}
          <img
            src="./logo-bellanor.png"
            alt="Bellanor"
            style={{
              width: 90, height: 90,
              objectFit: "contain",
              marginBottom: 16,
              filter: "drop-shadow(0 4px 12px rgba(215,190,124,0.2))",
            }}
            onError={e => { e.target.style.display = "none"; }}
          />
          <div className="serif" style={{
            fontSize: "clamp(44px, 12vw, 56px)",
            fontWeight: 600,
            background: T.gradient.goldPremium,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            letterSpacing: -1.8,
            lineHeight: 1,
            filter: "drop-shadow(0 2px 8px rgba(215,190,124,0.25))",
          }}>
            BELLANOR
          </div>

          <div style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            gap: 12, marginTop: 14,
          }}>
            <div style={{
              width: 32, height: 1,
              background: `linear-gradient(90deg, transparent, ${T.gold} 100%)`,
            }} />
            <span style={{
              fontSize: 10,
              letterSpacing: 4,
              textTransform: "uppercase",
              fontWeight: 700,
              color: T.gold,
            }}>
              Alta Performance
            </span>
            <div style={{
              width: 32, height: 1,
              background: `linear-gradient(270deg, transparent, ${T.gold} 100%)`,
            }} />
          </div>

          <div style={{
            marginTop: 20, fontSize: 13, color: T.textSec,
            fontStyle: "italic",
            fontFamily: "'Fraunces', Georgia, serif",
            letterSpacing: 0.3,
          }}>
            uma verdadeira experiência de mudança de vida
          </div>
        </div>

        {/* Card de login */}
        <div style={{
          background: T.gradient.cardHero,
          border: `1px solid ${T.borderMid}`,
          borderRadius: T.r.xl,
          padding: "32px 28px",
          boxShadow: T.shadow.lg,
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
        }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Input
              label="Usuário ou email"
              value={u} onChange={e => setU(e.target.value)}
              placeholder="seu.usuario ou email@exemplo.com"
              onKeyDown={e => e.key === "Enter" && tryLogin()}
              autoComplete="username"
            />

            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              <label style={{ fontSize: 11, color: T.textSub, fontWeight: 500, letterSpacing: 0.8, textTransform: "uppercase" }}>
                Senha
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type={show ? "text" : "password"}
                  value={p} onChange={e => setP(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  onKeyDown={e => e.key === "Enter" && tryLogin()}
                  onFocus={e => { e.target.style.borderColor = T.brand; e.target.style.boxShadow = `0 0 0 3px ${T.brand}25`; }}
                  onBlur={e => { e.target.style.borderColor = T.borderMid; e.target.style.boxShadow = "none"; }}
                  style={{
                    background: T.input,
                    border: `1px solid ${T.borderMid}`,
                    borderRadius: T.r.md,
                    padding: "12px 42px 12px 14px",
                    color: T.text,
                    fontSize: 14,
                    fontFamily: "inherit",
                    outline: "none",
                    width: "100%",
                    boxSizing: "border-box",
                    transition: `all 160ms ${T.ease}`,
                  }}
                />
                <button
                  onClick={() => setShow(x => !x)}
                  style={{
                    position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)",
                    background: "none", border: "none", color: T.textSub, cursor: "pointer",
                    padding: 4, display: "flex",
                  }}
                >{show ? <Icon.eyeOff size={16} /> : <Icon.eye size={16} />}</button>
              </div>
            </div>

            {err && (
              <Note tone="err" icon={<Icon.alert size={14} />}>
                {err}
              </Note>
            )}

            <Btn onClick={tryLogin} disabled={loading} style={{
              justifyContent: "center",
              padding: "13px",
              fontSize: 14,
              marginTop: 6,
              width: "100%",
              opacity: loading ? 0.6 : 1,
            }} icon={loading ? null : <Icon.arrow size={14} />}>
              {loading ? "Verificando..." : "Entrar"}
            </Btn>
          </div>
        </div>

        {/* Credenciais demo */}
        <div style={{
          textAlign: "center", marginTop: 28,
          fontSize: 10, color: T.textDim, letterSpacing: 1.5,
        }}>
          app.bellanor.com.br
        </div>
      </div>
    </div>
  );
}
